import React, { Component } from "react";
import { Link } from "react-router-dom";

import settings from "../../settings.js";

import Horn from "../../assets/horn.svg";
import Loader from "../../assets/loader.png";
import Scrollbars from "react-custom-scrollbars";
import Contract from "./contract.js";

class Contracts extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: true, data: [] };
  }
  componentDidMount() {
    this.loadData();
  }
  loadData() {
    this.setState({ isLoading: true });
    fetch(
      settings.server_url +
        "get_contracts_categories/" +
        window.sessionStorage.getItem("sid")
    )
      .then((res) => res.json())
      .then((response) => {
        this.setState({ data: response.data.data, isLoading: false });
      })
      .catch((error) => console.error("Error:", error));
  }

  render() {
    return (
      <div className="gridItem">
        <div className="gridHeader">
          <div className="gridHeaderTitle">Contacten en afspraken</div>
          <div className="gridHeaderAll">
            <Link to={"/contracten"} className="">
              Bekijk alles
            </Link>
          </div>
        </div>
        {this.state.isLoading ? (
          <Scrollbars style={{ height: 272 }}>
            <div className="gridRows loading"></div>
          </Scrollbars>
        ) : this.state.data.length > 0 ? (
          <Scrollbars style={{ height: 272 }}>
            <div className="gridRows">
              {this.state.data.map((contract, index) => (
                <Contract contract={contract} />
              ))}
            </div>
          </Scrollbars>
        ) : (
          <Scrollbars style={{ height: 272 }}>
            <div className="gridRows">
              <Contract contract={{ contractName: "Geen gegevens gevonden" }} />
            </div>
          </Scrollbars>
        )}
      </div>
    );
  }
}

export default Contracts;
